import { TenancyContentsInsuranceStatuses } from "./tenancy-contents-insurance-statuses";

export class TenancyContentsInsurancePost {
    status: TenancyContentsInsuranceStatuses;
    opened: boolean;
}
